export const littlemssamModsTest = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (desyncdata !== undefined) {
		if (desyncdata.indexOf('LittleMsSam') !== -1) {
			return {
				type: 'littlemssamModsTest',
				color: 'IndianRed',
				title: 'Outdated mods by LittleMsSam',
				text: 'You\'re potentially using an outdated mod made by LittleMsSam.',
				description: 'Remove and update all files related to the <strong>LittleMsSam</strong> creator.'
			}
		}
	}
}

// EXAMPLE
/*

*/



// WEBPACK FOOTER //
// ./src/tests/mods/authors/littlemssamModsTest.js